/**
 * TrendUpChartIcon — rising bars + trend arrow (weight gain).
 * Bars stay fully under the trend corridor (no stroke/bar overlap).
 */
import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function TrendUpChartIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      {/* Bars — tops clear of the stroke band above */}
      <Rect x="2" y="16.2" width="3" height="4.8" rx="0.5" fill={color} />
      <Rect x="6.1" y="14" width="3" height="7" rx="0.5" fill={color} />
      <Rect x="10.2" y="15" width="3" height="6" rx="0.5" fill={color} />
      <Rect x="14.3" y="12.2" width="3" height="8.8" rx="0.5" fill={color} />
      {/* Trend + arrow ride in the empty upper band */}
      <Path
        d="M3 13.2 L7.4 8.4 L11.4 10.8 L16.6 5.2"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <Path d="M14.9 6.35 L20.6 2.6 L19.2 8.4 Z" fill={color} />
    </Svg>
  );
}

export default TrendUpChartIcon;
